import { render, staticRenderFns } from "./activityProcedure.vue?vue&type=template&id=35fdaee0&scoped=true&"
import script from "./activityProcedure.vue?vue&type=script&lang=js&"
export * from "./activityProcedure.vue?vue&type=script&lang=js&"
import style0 from "./activityProcedure.vue?vue&type=style&index=0&id=35fdaee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdaee0",
  null
  
)

export default component.exports